{
  "name": "@vladmandic/human",
  "version": "3.0.6",
  "description": "Human: AI-powered 3D Face Detection & Rotation Tracking, Face Description & Recognition, Body Pose Tracking, 3D Hand & Finger Tracking, Iris Analysis, Age & Gender & Emotion Prediction, Gesture Recognition",
  "sideEffects": false,
  "main": "dist/human.node.js",
  "module": "dist/human.esm.js",
  "browser": "dist/human.esm.js",
  "types": "types/human.d.ts",
  "exports": {
    "node": {
      "require": "./dist/human.node.js",
      "import": "./dist/human.node.js",
      "module": "./dist/human.node.js"
    },
    "require": "./dist/human.node.js",
    "import": "./dist/human.esm.js",
    "script": "./dist/human.js",
    "module": "./dist/human.esm.js",
    "types": "./types/human.d.ts",
    "dist/human": "./dist/human.js",
    "dist/human.js": "./dist/human.js",
    "dist/human.esm": "./dist/human.esm.js",
    "dist/human.esm.js": "./dist/human.esm.js",
    "dist/human.esm-nobundle": "./dist/human.esm-nobundle.js",
    "dist/human.esm-nobundle.js": "./dist/human.esm-nobundle.js",
    "dist/human.node": "./dist/human.node.js",
    "dist/human.node.js": "./dist/human.node.js",
    "dist/human.node-wasm": "./dist/human.node-wasm.js",
    "dist/human.node-wasm.js": "./dist/human.node-wasm.js",
    "dist/human.node-gpu": "./dist/human.node-gpu.js",
    "dist/human.node-gpu.js": "./dist/human.node-gpu.js"
  },
  "author": "Vladimir Mandic <mandic00@live.com>",
  "bugs": {
    "url": "https://github.com/vladmandic/human/issues"
  },
  "homepage": "https://vladmandic.github.io/human/demo/index.html",
  "license": "MIT",
  "engines": {
    "node": ">=14.0.0"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/vladmandic/human.git"
  },
  "scripts": {
    "start": "node --no-warnings demo/nodejs/node.js",
    "dev": "build --profile development",
    "clean": "build --profile clean",
    "build": "rimraf test/build.log && node build.js",
    "test": "node --no-warnings --unhandled-rejections=strict --trace-uncaught test/node.js",
    "lint": "eslint *.json *.js src demo test models wiki",
    "scan": "npx auditjs@latest ossi --dev --quiet"
  },
  "keywords": [
    "human",
    "human-library",
    "face-detection",
    "faceid",
    "face-geometry",
    "face-embedding",
    "face-recognition",
    "face-description",
    "face-matching",
    "body-tracking",
    "body-segmentation",
    "hand-tracking",
    "iris-tracking",
    "age-estimation",
    "emotion-detection",
    "gender-prediction",
    "gesture-recognition",
    "gaze-tracking",
    "age-gender",
    "tensorflowjs",
    "tfjs",
    "tensorflow"
  ],
  "devDependencies": {
    "@html-eslint/eslint-plugin": "^0.18.0",
    "@html-eslint/parser": "^0.18.0",
    "@microsoft/api-extractor": "^7.34.8",
    "@tensorflow/tfjs-backend-cpu": "^4.5.0",
    "@tensorflow/tfjs-backend-wasm": "^4.5.0",
    "@tensorflow/tfjs-backend-webgl": "^4.5.0",
    "@tensorflow/tfjs-backend-webgpu": "0.0.1-alpha.20",
    "@tensorflow/tfjs-converter": "^4.5.0",
    "@tensorflow/tfjs-core": "^4.5.0",
    "@tensorflow/tfjs-data": "^4.5.0",
    "@tensorflow/tfjs-layers": "^4.5.0",
    "@tensorflow/tfjs-node": "^4.5.0",
    "@tensorflow/tfjs-node-gpu": "^4.5.0",
    "@types/node": "^20.1.0",
    "@types/offscreencanvas": "^2019.7.0",
    "@typescript-eslint/eslint-plugin": "^5.59.2",
    "@typescript-eslint/parser": "^5.59.2",
    "@vladmandic/build": "^0.9.2",
    "@vladmandic/pilogger": "^0.4.8",
    "@vladmandic/tfjs": "github:vladmandic/tfjs",
    "canvas": "^2.11.2",
    "esbuild": "^0.17.18",
    "eslint": "8.40.0",
    "eslint-config-airbnb-base": "^15.0.0",
    "eslint-plugin-html": "^7.1.0",
    "eslint-plugin-import": "^2.27.5",
    "eslint-plugin-json": "^3.1.0",
    "eslint-plugin-markdown": "^3.0.0",
    "eslint-plugin-node": "^11.1.0",
    "eslint-plugin-promise": "^6.1.1",
    "rimraf": "^5.0.0",
    "tslib": "^2.5.0",
    "typedoc": "0.24.7",
    "typescript": "5.0.4"
  }
}
